import Cb from "../components/content-blocks/cb";
import TemplateProjects from "../components/page-templates/template-projects";
import TemplateVacancies from "../components/page-templates/template-vacancies";
import TemplateMySamSam from "../components/page-templates/template-my-samsam";
import PageContent from "../components/page-content";
import {useEffect} from "react";
import {gtm} from "../lib/gtm";

export default function Page({page}) {
    // useEffect(() => {
    //   gtm.push({ event: "page_view" });
    // }, []);

    return (
        <>
            {page.template === "template-projects.php" ? (
                <TemplateProjects page={page}/>
            ) : page.template === "template-vacancies.php" ? (
                <TemplateVacancies page={page}/>
            ) : page.template === "template-my-samsam.php" ? (
                <TemplateMySamSam page={page}/>
            ) : page.content_blocks && page.content_blocks.length ? (
                <Cb blocks={page.content_blocks}/>
            ) : (
                <PageContent page={page}/>
            )}
        </>
    );
}

export async function getStaticPaths() {
    return {
        paths: [],
        fallback: "blocking",
    };
}

export async function getStaticProps({params}) {
    let slug = params.slug.join("/");

    const res = await fetch(
        `${process.env.API_URL}wp/v2/get-entity-by-slug?slug=${slug}&_embed`
    );
    const page = await res.json();

    if (/20[0-9]/.exec(res.status) !== null) {
        return {
            props: {
                page,
            },
            revalidate: 60,
        };
    } else {
        const res = await fetch(
            `${process.env.API_URL}wp/v2/get-redirect-by-slug?slug=/${slug}`
        );

        const redirect = await res.json();

        if (/20[0-9]/.exec(res.status) !== null) {
            return {
                redirect: {
                    destination: redirect.new_url,
                },
            };
        } else {
            return {
                notFound: true,
            };
        }
    }
}
